export default {
  "records": [
      {
      "id": 34,
      "icon": "../images/publications/pub63.png",
      "img": "../images/publications/pub63.png",
      "text": "Dr.Li has co-authored a paper published on Nature Communications Earth&Environment",
      "label": "Publication",
      "path": "https://www.nature.com/articles/s43247-026-03952-8",
      "date": "09-01-2026",
      "description": ""
    },
    {
      "id": 33,
      "icon": "../images/news/penn-today-urban-heat.png",
      "img": "../images/news/penn-today-urban-heat.png",
      "text": "Penn Today has a news article on Dr. Li's work of 'Can AI help cities get a handle on urban heat?'",
      "label": "News",
      "path": "https://penntoday.upenn.edu/news/weitzman-school-can-ai-help-cities-get-handle-urban-heat",
      "date": "08-18-2026",
      "description": ""
    },
    {
      "id": 32,
      "icon": "../images/publications/pub58.png",
      "img": "../images/publications/pub58.png",
      "text": "Dr. Li is co-author of a paper published on JAMA on the topic of Trends and Disparities in Heat-Related Emergency Medical Services Activations",
      "label": "Publication",
      "path": "https://jamanetwork.com/journals/jama/fullarticle/2844697",
      "date": "02-04-2026",
      "description": ""
    },

    {
      "id": 31,
      "icon": "../images/news/tip-2026.png",
      "img": "../images/news/tip-2026.png",
      "text": "Dr. Li joins 15-week seminar program is open to non-charter teachers throughout the School District of Philadelphia",
      "label": "Talk",
      "path": "https://theteachersinstitute.org/apply-to-tip/current-seminars/",
      "date": "02-01-2026",
      "description": ""
    },
    {
      "id": 30,
      "icon": "../images/news/nsf_career_graphic.jpg",
      "img": "../images/news/nsf_career_graphic.jpg",
      "text": "Dr. Li has been awarded prestigious National Science Foundation CAREER award to support his research on scalable AI for urban heat modeling and mitigation",
      "label": "Grant",
      "path": "",
      "date": "01-20-2026",
      "description": ""
    },

    {
      "id": 29,
      "icon": "../images/publications/pub57.png",
      "img": "../images/publications/pub57.png",
      "text": "Shengao Yi leads a research that published on Journal of Transport Geography ",
      "label": "Publication",
      "path": "https://www.sciencedirect.com/science/article/abs/pii/S0966692326000074",
      "date": "1-12-2026",
      "description": ""
    },
    {
      "id": 28,
      "icon": "../images/news/sloangrant2025.png",
      "img": "../images/news/sloangrant2025.png",
      "text": "Dr. Li has been awarded $1 million grant from Sloan Energy and Environment grant with collaborators from ASU and Temple",
      "label": "Grant",
      "path": "https://sloan.org/programs/research/energy-and-environment/announcing-energy-system-interactions-rfp-grantees",
      "date": "12-23-2025",
      "description": ""
    },
    {
      "id": 27,
      "icon": "../images/publications/pub56.png",
      "img": "../images/publications/pub56.png",
      "text": "A new paper published on Urban Forestry and Urban Greening on a multimodal AI framework for hyperlocal spatio-temporal urban heat stress prediction and mitigation",
      "label": "Publication",
      "path": "https://www.sciencedirect.com/science/article/pii/S1618866725004352",
      "date": "10-23-2025",
      "description": ""
    },
    {
    //   "id": 25,
    //   "icon": "",
    //   "img": "",
    //   "text": "Kickoff meeting of NASA grant at University of North Carolina, Chapel Hill",
    //   "label": "Meeting",
    //   "path": "none",
    //   "date": "3-11-2024",
    //   "description": `Unfortunately, comprehensive and scale-relevant measurements of heat stress, 
    //   as experienced by humans, has proven elusive within cities. 
    //   collect data (air temperature, humidity, etc.). 
    //   <br><br> 
    //   Our team from University of North Carolina, Chapel Hill, Temple/University of Pennsylvania, 
    //   Pacific Northwestern National Lab, Arizona State University recently has been awarded $1.5 
    //   million grant from NASA. Our team aims to combine satellite observation data, microclimate 
    //   modeling, and high performance computing to generate hyperlocal level heat exposure level 
    //   in multiple US cities and investigate the potential environmental inequities in terms
    //    of heat exposure in US cities, (<a style='color:blue; text-decoration: underline;' 
    //    href='https://xiaojianggis.github.io/heatexpo/'>previous work</a>). 
    //    The result of this project will also provide more actionable insight for heat 
    //    mitigation and adaptation in US cities. We also talked with local communities,
    //    government agencies in research triangle in North Carolina in this kickoff meeting.`
    // },
    
      "id": 26,
      "icon": "../images/publications/pub55.png",
      "img": "../images/publications/pub55.png",
      "text": "A new paper published on Computers, Environment and Urban Systems on examining the heat stress around bus stops in Philadelphia",
      "label": "Publication",
      "path": "https://www.sciencedirect.com/science/article/pii/S0198971525000948",
      "date": "9-10-2025",
      "description": ""
    },
    {
      "id": 25,
      "icon": "../images/news/penn_today.png",
      "img": "../images/news/penn_today.png",
      "text": "Our work of 'Mapping smarter tree placement' featured on Penn Today!",
      "label": "News",
      "path": "https://penntoday.upenn.edu/news/weitzman-student-maps-smarter-tree-placement-philadelphia-and-beyond",
      "date": "9-5-2025",
      "description": ""
    },
    {
      "id": 24,
      "icon": "../images/publications/pub54.png",
      "img": "../images/publications/pub54.png",
      "text": "A new paper published on Journal of Transport Geography on measuring exposruer to extreme heat in public transit system",
      "label": "Publication",
      "path": "https://www.sciencedirect.com/science/article/pii/S0966692325002741",
      "date": "8-11-2025"
    },

    {
      "id": 23,
      "icon": "../images/news/ncar-2025.png",
      "img": "../images/news/ncar-2025.png",
      "text": "Dr. Li was invited to present at the NSF workshop of Urban Heat Island hosted by National Center for Atmospheric Research (NCAR) ",
      "label": "News",
      "path": "https://ncar.ucar.edu/",
      "date": "6-28-2025",
      "description": ""
    },

    {
      "id": 22,
      "icon": "../images/news/penn_design_qa.jpg",
      "img": "../images/news/penn_design_qa.jpg",
      "text": "Dr. Li has a Q&A on UPenn School of Design talk about Urban Environmental Analytics, AI, and more",
      "label": "News",
      "path": "https://www.design.upenn.edu/post/qa-xiaojiang-li-assistant-professor-city-regional-planning",
      "date": "4-24-2025",
      "description": "As climate change continues <a style='color:blue; text-decoration: underline;' href='https://en.wikipedia.org/wiki/Banana'>here</a> to set record heat temperatures across the globe, scientists and policymakers are looking for ways to mitigate the effects of heat exposure on human health. Exposure to excessive heat not only causes uncomfortable symptoms, like respiratory complications, heat cramps, exhaustion, heat stroke and dehydration, it can be fatal. According to the National Weather Service, heat kills more people in the U.S. than floods, hurricanes and tornadoes combined. Extreme heat is even more dangerous in urban areas, where crowded buildings and impervious surfaces such as asphalt contribute to a phenomenon called the urban heat island effect. This puts low-income populations and people of color who are disproportionally exposed to higher temperatures within urban areas at higher risk."
    },
    {
      "id": 21,
      "icon": "../images/publications/pub50.png",
      "img": "../images/publications/pub50.png",
      "text": "A new paper of assessing the differential impact of landscapes on heat exposure environment was published on Building and Environment'",
      "label": "Publication",
      "path": "https://www.sciencedirect.com/science/article/pii/S0360132325000204?via%3Dihub",
      "date": "1-19-2025",
      "description": ""
    },
    {
      "id": 20,
      "icon": "../images/publications/pub49.png",
      "img": "../images/publications/pub49.png",
      "text": "A new paper of pedestrian level heat exposure was published on Environment and Planning B'",
      "label": "Publication",
      "path": "https://journals.sagepub.com/doi/full/10.1177/23998083241274391?casa_token=PJwI_IbyS9cAAAAA%3AQMszajOl2i0_app0qDQ2XUiXozrTsT2aK-xeCXJOXaKgk6VzzcJvhEvGzNUhCfIhUYfzndrAUox-8g",
      "date": "8-19-2024",
      "description": ""
    },
    {
      "id": 19,
      "icon": "../images/projects/pedheat.png",
      "img": "../images/projects/pedheat.png",
      "text": "We have launched the website of a new project of 'pedestrian heat exposure'",
      "label": "Project",
      "path": "https://xiaojianggis.github.io/pedheat/",
      "date": "8-11-2024",
      "description": "As climate change continues <a style='color:blue; text-decoration: underline;' href='https://en.wikipedia.org/wiki/Banana'>here</a> to set record heat temperatures across the globe, scientists and policymakers are looking for ways to mitigate the effects of heat exposure on human health. Exposure to excessive heat not only causes uncomfortable symptoms, like respiratory complications, heat cramps, exhaustion, heat stroke and dehydration, it can be fatal. According to the National Weather Service, heat kills more people in the U.S. than floods, hurricanes and tornadoes combined. Extreme heat is even more dangerous in urban areas, where crowded buildings and impervious surfaces such as asphalt contribute to a phenomenon called the urban heat island effect. This puts low-income populations and people of color who are disproportionally exposed to higher temperatures within urban areas at higher risk."
    },
    {
      "id": 18,
      "icon": "../images/publications/pub48.png",
      "img": "../images/publications/pub48.png",
      "text": "Our paper of sensitivity and vulnerability to urban heat in 14 US cities has published on Environmental Research Letter",
      "label": "Publication",
      "path": "https://iopscience.iop.org/article/10.1088/1748-9326/ad6c64",
      "date": "8-8-2024",
      "description": "As climate change continues <a style='color:blue; text-decoration: underline;' href='https://en.wikipedia.org/wiki/Banana'>here</a> to set record heat temperatures across the globe, scientists and policymakers are looking for ways to mitigate the effects of heat exposure on human health. Exposure to excessive heat not only causes uncomfortable symptoms, like respiratory complications, heat cramps, exhaustion, heat stroke and dehydration, it can be fatal. According to the National Weather Service, heat kills more people in the U.S. than floods, hurricanes and tornadoes combined. Extreme heat is even more dangerous in urban areas, where crowded buildings and impervious surfaces such as asphalt contribute to a phenomenon called the urban heat island effect. This puts low-income populations and people of color who are disproportionally exposed to higher temperatures within urban areas at higher risk."
    },
    {
      "id": 17,
      "icon": "../images/publications/pub47.png",
      "img": "../images/publications/pub47.png",
      "text": "PhD student Shengao has his first first-author paper published on flagship journal Sustainable City and Society",
      "label": "Publication",
      "path": "https://www.sciencedirect.com/science/article/pii/S2210670724005201?via%3Dihub",
      "date": "8-1-2024",
      "description": "As climate change continues <a style='color:blue; text-decoration: underline;' href='https://en.wikipedia.org/wiki/Banana'>here</a> to set record heat temperatures across the globe, scientists and policymakers are looking for ways to mitigate the effects of heat exposure on human health. Exposure to excessive heat not only causes uncomfortable symptoms, like respiratory complications, heat cramps, exhaustion, heat stroke and dehydration, it can be fatal. According to the National Weather Service, heat kills more people in the U.S. than floods, hurricanes and tornadoes combined. Extreme heat is even more dangerous in urban areas, where crowded buildings and impervious surfaces such as asphalt contribute to a phenomenon called the urban heat island effect. This puts low-income populations and people of color who are disproportionally exposed to higher temperatures within urban areas at higher risk."
    },
    {
      "id": 16,
      "icon": "../images/news/join-penn.png",
      "img": "../images/news/join-penn.png",
      "text": "Dr. Li joins Department of City and Regional Planning, School of Design, University of Pennsylvania as faculty",
      "label": "News",
      "path": "https://www.design.upenn.edu/post/weitzman-welcomes-new-faculty-and-department-chairs-2024-2025-academic-year",
      "date": "7-1-2024",
      "description": "As climate change continues <a style='color:blue; text-decoration: underline;' href='https://en.wikipedia.org/wiki/Banana'>here</a> to set record heat temperatures across the globe, scientists and policymakers are looking for ways to mitigate the effects of heat exposure on human health. Exposure to excessive heat not only causes uncomfortable symptoms, like respiratory complications, heat cramps, exhaustion, heat stroke and dehydration, it can be fatal. According to the National Weather Service, heat kills more people in the U.S. than floods, hurricanes and tornadoes combined. Extreme heat is even more dangerous in urban areas, where crowded buildings and impervious surfaces such as asphalt contribute to a phenomenon called the urban heat island effect. This puts low-income populations and people of color who are disproportionally exposed to higher temperatures within urban areas at higher risk."
    },
    {
      "id": 15,
      "icon": "../images/news/stanford-05-07-2024/talk.png",
      "img": "../images/news/nasa/nasa-meeting.jpeg",
      "text": "Dr. Li gave a talk of 'Urban Environmental Analytics' at Stanford University on Zoom",
      "label": "Talk",
      "path": "https://naturalcapitalproject.stanford.edu/",
      "date": "5-7-2024",
      "description": "As climate change continues <a style='color:blue; text-decoration: underline;' href='https://en.wikipedia.org/wiki/Banana'>here</a> to set record heat temperatures across the globe, scientists and policymakers are looking for ways to mitigate the effects of heat exposure on human health. Exposure to excessive heat not only causes uncomfortable symptoms, like respiratory complications, heat cramps, exhaustion, heat stroke and dehydration, it can be fatal. According to the National Weather Service, heat kills more people in the U.S. than floods, hurricanes and tornadoes combined. Extreme heat is even more dangerous in urban areas, where crowded buildings and impervious surfaces such as asphalt contribute to a phenomenon called the urban heat island effect. This puts low-income populations and people of color who are disproportionally exposed to higher temperatures within urban areas at higher risk."
    },
    {
      "id": 14,
      "icon": "../images/news/05-01-2024-land-pub.jpg",
      "img": "../images/news/05-01-2024-land-pub.jpg",
      "text": "Dr. Li has a co-authored paper published on Landscape and Urban Planning",
      "label": "Publication",
      "path": "https://www.sciencedirect.com/science/article/pii/S0169204624000793",
      "date": "5-1-2024",
      "description": ""
    },
    {
      "id": 13,
      "icon": "../images/news/nasa/nasa-meeting.jpeg",
      "img": "../images/news/nasa/nasa-meeting.jpeg",
      "text": "Kickoff meeting of NASA grant at University of North Carolina, Chapel Hill",
      "label": "Meeting",
      "path": "none",
      "date": "3-11-2024",
      "description": `
      The Urban Heat Island (UHI) effect exposes urban residents to higher temperatures 
      than nearby non-urban populations. Global climate change would add to this UHI effect – with direct,
       detrimental effects on human health and socioeconomic outcomes. Exposure to excessive heat can be fatal,
        and, at lower intensity, it can also cause general discomfort, respiratory problems, heat cramps 
        and exhaustion, heat stroke, and dehydration – contributing in turn to reduced learning and labor 
        productivity. The IPCC Sixth Assessment Report on Climate Change anticipates increases in the 
        frequency and intensity of heat waves, with pernicious effects that interact dynamically with 
        urban heat exposure.  

  <figure style="text-align:center; margin: 20px 0;">
    <img 
      src="../images/news/nasa/nasa-meeting.jpeg" 
      alt="NASA Kickoff Meeting" 
      style="max-width: 100%; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);" 
    />
    <figcaption style="font-size: 0.9rem; color: #666;">
      NASA Kickoff Meeting, University of North Carolina
    </figcaption>
  </figure>

        <br><br>
        In the U.S., people of color and low-income individuals disproportionately live in areas with
         potential for higher heat exposure. Measuring heat exposure in urban areas is thus important 
         for protecting and improving human health and creating equitable outcomes. Accurate and timely
          measurements are key for both micro-level policy decisions (e.g., where exactly to undertake 
          heat mitigation investments) and macro-level policy analysis (e.g., whether mitigation policies
           are reducing disparities in exposure by race and income). Unfortunately, comprehensive and 
           scale-relevant measurements of heat stress, as experienced by humans, has proven elusive 
           within cities. Ground-based monitors can collect data (air temperature, humidity, etc.). 
        <br><br>

        Our team from University of North Carolina, Chapel Hill, Temple/University of Pennsylvania, 
        Pacific Northwestern National Lab, Arizona State University recently has been awarded $1.5 
        million grant from NASA. Our team aims to combine satellite observation data, microclimate 
        modeling, and high performance computing to generate hyperlocal level heat exposure level 
        in multiple US cities and investigate the potential environmental inequities in terms 
        of heat exposure in US cities, (<a style='color:blue; text-decoration: underline;' 
        href='https://xiaojianggis.github.io/heatexpo/'>previous work</a>). The result of 
        this project will also provide more actionable insight for heat mitigation and 
        adaptation in US cities. We also talked with local communities, government agencies 
        in research triangle in North Carolina in this kickoff meeting.`

    },

    {
      "id": 36,
      "icon": "../images/news/drexel/drexel.png",
      "img": "../images/news/drexel/drexel.png",
      "text": "Prof. Xiaojiang Li was invited to give a lecture at Drexel University",
      "label": "Lecture",
      "path": "https://drexel.edu/hunger-free-center/news-events/events/details/?eid=39427&iid=105384",
      "date": "10-25-2023",
      "description": "none"
    },
    {
      "id": 12,
      "icon": "../images/news/nasa.png",
      "img": "../images/news/nasa/nasa-meeting.jpeg",
      "text": "Prof. Xiaojiang Li with collaborators from UNC, PNNL, ASU been awarded $1.5 million grant from NASA",
      "label": "Grant",
      "path": "https://ie.unc.edu/news/unc-research-team-awarded-1-5-million-nasa-grant-to-explore-disparities-and-solutions-to-urban-heat-stress-and-climate-justice-in-u-s/",
      "date": "10-05-2023",
      "description": "none"
    },
    {
      "id": 11,
      "icon": "../images/news/8-1-2023-nsf-hegs.png",
      "text": "Prof. Xiaojiang Li has been awarded NSF grant as sole principle investigator",
      "label": "Grant",
      "path": "https://www.nsf.gov/awardsearch/showAward?AWD_ID=2314709&HistoricalAwards=false",
      "date": "08-09-2023"
    },
    {
      "id": 10,
      "icon": "../images/news/7-16-2023-urbanclimate-publication.jpeg",
      "text": "Prof. Xiaojiang Li has a new paper published on journal of Urban Climate",
      "label": "Publication",
      "path": "https://www.sciencedirect.com/science/article/abs/pii/S2212095523002092",
      "date": "07-16-2023"
    },
    {
      "id": 9,
      "icon": "../images/news/06-07-2023-ucgis.png",
      "text": "Prof. Xiaojiang Li presents at UCGIS sympothum of 'Pedestrian level heat exposure modeling and mapping'",
      "label": "Presentation",
      "path": "https://www.ucgis.org/symposium-2023",
      "date": "06-07-2023"
    },
    {
      "id": 8,
      "icon": "../images/news/05-14-2023-ICB.png",
      "text": "Prof. Xiaojiang Li presents at 23rd International Congress of Biometeorology at Arizona State University",
      "label": "Presentation",
      "path": "https://biomet23.asu.edu/",
      "date": "05-14-2023"
    },
    {
      "id": 7,
      "icon": "../images/news/03-24-2-23-AAG-denver.png",
      "text": "Prof. Xiaojiang Li presents at AAG annual conference at Denver",
      "label": "Presentation",
      "path": "https://www.aag.org/events/aag2023/",
      "date": "03-24-2023"
    },
    {
      "id": 6,
      "icon": "../images/news/02-27-2023-DigitalTwin-asu.png",
      "text": "Prof. Xiaojiang Li was invited to present at Workshop of digital twins in Geospatial Research at Arizona State University",
      "label": "Presentation",
      "path": "https://sgsup.asu.edu/node/9358",
      "date": "02-27-2023"
    },
    {
      "id": 5,
      "icon": "../images/news/02-02-2023-jhu.png",
      "text": "Prof. Xiaojiang Li presents at Johns Hopkins Bromery Lectures of 'Geospatial Data Science for Sustainability'",
      "label": "Presentation",
      "path": "https://eps.jhu.edu/events/bromery-lectures/",
      "date": "02-02-2023"
    },
    {
      "id": 35,
      "icon": "../images/news/jhu/department.png",
      "text": "Prof. Xiaojiang Li is going to be on sabbatical at Johns Hopkins University in 2023 ",
      "label": "Event",
      "path": "https://eps.jhu.edu/",
      "date": "11-02-2022"
    },
    {
      "id": 4,
      "icon": "../images/news/8-3-2022-harvard.png",
      "text": "Prof. Xiaojiang Li presents at Harvard University of 'Mapping urban heat exposure in US cities'",
      "label": "Presentation",
      "path": "https://gis.harvard.edu/event/mapping-urban-outdoor-heat-exposure-using-us-cities",
      "date": "08-02-2022"
    },
    {
      "id": 3,
      "icon": "../images/news/8-2-2022-mit.png",
      "text": "Prof. Xiaojiang Li made a presentation of 'Urban Microclimate Modeling' at Senseable City Lab, MIT",
      "label": "Presentation",
      "path": "none",
      "date": "08-01-2022"
    },
    {
      "id": 2,
      "icon": "../images/news/6-2-2022-cornell.png",
      "text": "Prof. Xiaojiang Li made a guest lecture of 'Urban Analytics for Urban Environmental Sustainability' at at Cornell University",
      "label": "Presentation",
      "path": "none",
      "date": "06-01-2022"
    },
    {
      "id": 1,
      "icon": "../images/news/5-2-2022-penn.png",
      "text": "Prof. Xiaojiang Li was invited to give a lecture of 'Urban Analytics for Urban Environmental Sustainability' at University of Pennsylvania",
      "label": "Presentation",
      "path": "none",
      "date": "05-01-2022"
    },
    {
      "id": 0,
      "icon": "../images/news/risingstar.png",
      "text": "Prof. Xiaojiang Li has been selected as 50 Rising stars in Geospatial World",
      "label": "Award",
      "path": "https://www.geospatialworld.net/rising-stars/2021/index.html"
    }
  ]
}